import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { RequiredToggle } from 'apps/builder/components/settings/modal/shared'

export const AttachmentField = ({ guid, required, type, label, keyField }) => (
  <>
  <div className="settings--row no-border">
    <SettingsFieldSelect
      guid={guid}
      label={label}
      keyField={keyField}
      type={type}
    />
    <div className="toggles-group">
      <div className="toggle-wrapper">
        <RequiredToggle guid={guid} active={required} />
      </div>
    </div>
  </div>
</>
)